module.exports = __webpack_public_path__ + "media/1x1/nz-7dab6e5e.svg";